/**
 * Vincent B776 (Eric 2026-02-17 SPEC STRICK PROD) — Format d'affichage
 * compact des noms de locuteurs dans les colonnes étroites (Whisper /
 * Fireflies / Merged).
 *
 * Vincent veut deux lignes courtes (prénom + saut de ligne + nom) au lieu
 * d'un seul long libellé qui gonfle la colonne à 140 px et vole de la
 * place au texte de la transcription. Retour d'un tuple {first, last}
 * que les composants rendent sur 2 lignes via <br/> ou flex-col.
 *
 * Règles :
 *   - "Alice Tremblay" → {first: "Alice", last: "Tremblay"}
 *   - "Speaker A" → {first: "Speaker", last: "A"} (2 tokens, on split)
 *   - "Vincent Van Gogh" → {first: "Vincent", last: "Van Gogh"} (3+
 *     tokens : le PREMIER token va à first, tout le reste à last).
 *   - "Marie-Claude Dubois" → {first: "Marie-Claude", last: "Dubois"}
 *   - "Alice" (1 seul token) → {first: "Alice", last: ""}
 *   - "" ou null → {first: "—", last: ""}
 */

/**
 * Tâche 1325 (Eric 2026-06-30) — Pourquoi il n'y a PAS de conversion ici.
 *
 * Un premier essai convertissait « Speaker 1 » en « Speaker A » à l'affichage,
 * pour rattraper les transcriptions écrites avant que le vocabulaire soit
 * unifié. Résultat observé à l'écran : la légende d'une vidéo affichait DEUX
 * « Speaker A ». La transcription fusionnée mêle en effet des tours venus de
 * Whisper (« Speaker 1 ») et des tours diarisés (« Speaker A ») — deux
 * locuteurs distincts se retrouvaient donc sous le même nom, ce qui est pire
 * que l'incohérence qu'on voulait masquer.
 *
 * L'alignement se fait désormais LÀ OÙ SONT LES DONNÉES
 * (`scripts/migrer_1325_locuteurs_en_lettres.py`), qui s'abstient et signale
 * quand un renommage fusionnerait deux locuteurs. Sur ces rares vidéos,
 * l'écran montre honnêtement « Speaker 1 » et « Speaker A » séparés : c'est
 * exact, et cela reste arbitrable à la main.
 */

export function formatSpeakerName(raw) {
  if (!raw || typeof raw !== "string") return { first: "—", last: "" };
  const s = raw.trim();
  if (!s) return { first: "—", last: "" };
  // On splitte sur le PREMIER espace pour tenir « Marie-Claude Dubois »
  // ou « Van Gogh » — le tirai est un token.
  const idx = s.indexOf(" ");
  if (idx === -1) return { first: s, last: "" };
  return { first: s.slice(0, idx), last: s.slice(idx + 1) };
}

/**
 * Retourne un JSX-friendly array de deux lignes prêtes à rendre.
 * Utilisation : `formatSpeakerLines("Alice Tremblay")` →
 * `["Alice", "Tremblay"]`. Les composants sont libres d'insérer un
 * <br/> ou un flex-col pour empiler.
 */
export function formatSpeakerLines(raw) {
  const { first, last } = formatSpeakerName(raw);
  return last ? [first, last] : [first];
}
